import service from '@/utils/request'

/** 获取商品分类列表 */
export function getCategories(mallType = 0, status = '') {
  return service.get(`/backend/goods/category/list?mallType=${mallType}&status=${status}`)
}

/** 保存商品分类数据 */
export function saveCategory(data) {
  return service.post('/backend/goods/category/submit', data)
}

/** 删除商品分类 */
export function removeCategory(data) {
  return service.post('/backend/goods/category/remove', data)
}

/** 获取商品品牌列表 */
export function getBrandList() {
  return service.get('/backend/goods/brand/list')
}

/** 获取商品列表 */
export function getGoodsList(params) {
  return service.post('/backend/goods/list', params)
}

/** 保存商品数据 */
export function saveGoods(data) {
  return service.post('/backend/goods/detail/submit', data)
}

/** 更新商品状态 */
export function updateGoodsStatus(data) {
  return service.put('/backend/goods/detail/status', data)
}

/** 删除商品数据 */
export function deleteGoods(data) {
  return service.delete(`/backend/goods/detail/remove`, { data })
}

/** 获取商品详情 */
export function getDetail(params) {
  return service.get(`/backend/goods/detail/${params}`)
}

/** 删除商品营销资料 */
export function removePromotion(data) {
  return service.delete(`/backend/goods/promotion/remove`, { data })
}

/** 更新商品营销资料状态 */
export function updatePromotionStatus(data) {
  return service.put(`/backend/goods/promotion/status`, data)
}

// /** 获取礼品列表 */
// export function getGiftPackList(data) {
//   return service.post('/backend/goods/giftpack/list', data)
// }

// /** 获取礼品详情 */
// export function getGiftDetail(params) {
//   return service.get('/backend/goods/giftpack/detail', { params })
// }

// /** 保存礼品数据 */
// export function saveGiftPack(data) {
//   return service.post('/backend/goods/giftpack/submit', data)
// }

// /** 更新礼品状态 */
// export function updateGiftStatus(data) {
//   return service.put('/backend/goods/giftpack/status', data)
// }

// /** 删除礼品 */
// export function deleteGiftPack(data) {
//   return service.delete('/backend/goods/giftpack/remove', { data })
// }

// /** 删除礼品营销资料 */
// export function removeGiftPromotion(data) {
//   return service.delete(`/backend/goods/giftpack/promotion/remove`, { data })
// }

// /** 更新商品营销资料状态 */
// export function updateGiftPromotionStatus(data) {
//   return service.put(`/backend/goods/giftpack/promotion/status`, data)
// }

/** 从特权礼包复制资料到商城 */
export function copyGiftPackage(idList) {
  return service.post('/backend/goods/giftpack/copy', idList)
}
